export interface ResumeProfile {
  fullName: string;
  email: string;
  phone: string;
  location: string;
  summary: string;
}

export interface Experience {
  id: string;
  company: string;
  title: string;
  startDate: string;
  endDate: string;
  bullets: string[];
}

export interface Education {
  id: string;
  school: string;
  degree: string;
  field: string;
  graduationDate: string;
}

export type TemplateId = 'classic' | 'minimal' | 'student' | 'modern-clean' | 'career-change';

export interface AiUsage {
  anonymousId: string;
  usedCount: number;
  maxFreeCount: number;
  subscription: 'free' | 'pro' | 'lifetime';
}

export interface ResumeState {
  profile: ResumeProfile;
  experience: Experience[];
  education: Education[];
  skills: string[];
  selectedTemplate: TemplateId;
  aiUsage: AiUsage;
}

export interface AIRewriteRequest {
  resumeText: string;
  jobTitle?: string;
  jobDescription?: string;
  anonymousId: string;
  model?: 'gpt-4o-mini' | 'claude-3-haiku';
}

export interface AIRewriteResponse {
  bullets: string[];
  quotaRemaining: number;
  model: string;
}

export interface AIErrorResponse {
  error: 'INVALID_REQUEST' | 'RATE_LIMITED' | 'AI_PROVIDER_ERROR' | 'INTERNAL_ERROR';
  message?: string;
  field?: string;
  retryAfter?: number;
}

export interface TemplateInfo {
  id: TemplateId;
  name: string;
  description: string;
  isPro: boolean;
  tag?: string;
}

export const TEMPLATES: TemplateInfo[] = [
  { id: 'classic', name: 'Classic', description: 'Clean and traditional.', isPro: false, tag: 'ATS-friendly' },
  { id: 'student', name: 'Student', description: 'Designed for first resumes.', isPro: false, tag: 'Entry-level' },
  { id: 'minimal', name: 'Minimal', description: 'Simple and airy.', isPro: true, tag: 'Pro' },
  { id: 'modern-clean', name: 'Modern Clean', description: 'Professional modern layout.', isPro: true, tag: 'Pro' },
  { id: 'career-change', name: 'Career Change', description: 'Highlights transferable skills.', isPro: true, tag: 'Pro' },
];

export const FREE_TEMPLATE_IDS: TemplateId[] = TEMPLATES.filter((t) => !t.isPro).map((t) => t.id);
